import styled from 'styled-components'

export const HtmlContainer = styled.div`
  color: var(--typography400);
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
`

export const ArticleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0;
`
